import React from "react";
import { Col, Row } from "react-bootstrap";
import FundtransferBtn from "./FundtransferBtn";
import { useNavigate } from "react-router-dom";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var PaymentOnUPI = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-3" },
            React.createElement(Col, { lg: 12, className: "mgt-15 d-flex align-items-center justify-content-center" },
                React.createElement("span", { className: "DMSansMedium_20_500 txt-midnight-blue" }, props.headSection)),
            React.createElement(Col, { lg: 12, className: "mgt-15 text-center" },
                React.createElement("span", { className: "DMSan_14_500 txt_blackOne1" }, props.subheadSection)),
            React.createElement(Col, { lg: 12, className: "mgt-30" },
                React.createElement("span", null, props.asideSection)),
            React.createElement(Col, { lg: 12, className: "mt-5" },
                React.createElement("span", { className: "DMSansMedium_12_500 txt-midnight-blue" }, "Please Note")),
            React.createElement(Col, { lg: 12, className: "mgt-10" },
                React.createElement("ul", { className: "disc-style color-gray " }, props.liData.map(function (listData, idx) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("li", null, listData.listcontent)));
                })))),
        props.btnshow ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement("div", null,
                        React.createElement(FundtransferBtn, { btnvalueleft: {
                                value: "Cancel",
                                btnTyp: "midnight-blue-underline",
                                className: "w-100 me-2 editcancel ",
                                onClick: function () {
                                    navigate("/fund-transfer");
                                },
                            }, btnvalueright: {
                                value: "Add Funds",
                                btnTyp: "midnight-blue",
                                className: "w-100 ms-2 ",
                            }, parentClass: device && device.isDesktop
                                ? "topborder common-fixedbtm-btm-desktop p-4"
                                : "topborder col-sm-12 common-fixedbtm-btn p-4" })))))) : null));
};
export default PaymentOnUPI;
